import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';
import * as styles from './AgreementField.css';
import { stopPropagation } from '../../../utils/events';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AgreementField = function AgreementField(_ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    privacyPolicyUrl = _ref.privacyPolicyUrl;
  var handleChange = React.useCallback(function (event, value) {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['agreement'],
    children: [/*#__PURE__*/_jsx(Checkbox, {
      id: "cbw-user-agreement",
      checked: checked,
      disabled: disabled,
      onChange: handleChange
    }), /*#__PURE__*/_jsxs("label", {
      className: styles['label'],
      htmlFor: "cbw-user-agreement",
      children: ["\u042F \u0434\u0430\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430", ' ', /*#__PURE__*/_jsx("a", {
        className: styles['link'],
        href: privacyPolicyUrl,
        onClick: stopPropagation,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043C\u043E\u0438\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"
      })]
    })]
  });
};